export const base64encode = (text: string) => {
  if (typeof window === "undefined") {
    return Buffer.from(text).toString("base64");
  }

  return window.btoa(
    encodeURIComponent(text).replace(/%([0-9A-F]{2})/g, (_, p1) => String.fromCharCode(parseInt(p1, 16)))
  );
};
